define(function riqChildFormStateMutationModule() {
  'use strict';
  var mutations = function mutations() {
    return {
      /**
       * Init state
       * @function init
       * @return {Object} - new state
       **/
      init: function init() {
        return {
          profileUuid: '',
          name: '',
          level: '',
          levelId: '',
          levelLabel: '',
          levels: [],
          avatar: '',
          avatarUrl: '',
          avatars: [],
          formState: '',
          view: 'childForm',
          placementAssessment: [],
          placementAssessmentLevels: [],
          activeReadingLevel: [],
          activeReadingLevelType: '',
          profileGradeLevel: '',
          errorCode: 0,
          inputErrors: {}
        };
      },
      setState: function setState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, _payload);
      },
      setFirstName: function setFirstName(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          name: _payload
        });
      },
      setLevel: function setLevel(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          level: _payload || '',
          levelLabel: _payload ? _payload.gradeLabel : '',
          levelId: _payload ? _payload.id : ''
        });
      },
      setLevels: function setLevels(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          levels: _payload
        });
      },
      setAvatar: function setAvatar(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          avatar: _payload.avatar,
          avatarUrl: _payload.avatarUrl
        });
      },
      setAvatars: function setAvatars(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          avatars: _payload
        });
      },
      setPlacementAssessment: function setPlacementAssessment(
        _moduleState,
        _payload
      ) {
        return Object.assign({}, _moduleState, {
          placementAssessment: _payload
        });
      },
      setPlacementAssessmentLevels: function setPlacementAssessmentLevels(
        _moduleState,
        _payload
      ) {
        return Object.assign({}, _moduleState, {
          placementAssessmentLevels: _payload
        });
      },
      setView: function setView(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          view: _payload
        });
      },
      setFormState: function setFormState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          formState: _payload
        });
      },
      clearData: function clearData(_moduleState) {
        var nextModuleMutation = {
          profileUuid: '',
          name: '',
          level: '',
          levelId: '',
          levelLabel: '',
          levels: [],
          avatars: [],
          avatar: '',
          avatarUrl: '',
          formState: '',
          view: 'childForm',
          placementAssessment: [],
          placementAssessmentLevels: [],
          activeReadingLevel: [],
          activeReadingLevelType: '',
          profileGradeLevel: '',
          errorCode: 0,
          inputErrors: {}
        };
        return Object.assign({}, _moduleState, nextModuleMutation);
      },
      clearError: function clearError(_moduleState) {
        return Object.assign({}, _moduleState, {
          errorCode: 0,
          inputErrors: {}
        });
      },
      setErrorCode: function setErrorCode(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          errorCode: _payload
        });
      },
      setInputErrors: function setInputErrors(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          inputErrors: _payload
        });
      }
    };
  };

  return mutations;
});
